"use client"

import { useMemo } from "react"

import { useFetchBooks } from "@/hooks/api/books"

import { SelectInput } from "./forms/inputs/select-input"

interface BookSelectInputProps {
  id?: string
  value: string | null
  onChange: (value: string | null) => void
  placeholder?: string
  className?: string
  size?: "sm" | "default"
}

export function BookSelectInput({
  id = "book-select",
  value,
  onChange,
  placeholder = "Select book",
  className,
  size = "sm",
}: BookSelectInputProps) {
  const { data: booksData, isLoading } = useFetchBooks()

  const options = useMemo(() => {
    return (
      booksData?.books?.map((book) => ({
        value: book.id,
        label: book.name,
      })) ?? []
    )
  }, [booksData?.books])

  return (
    <SelectInput
      id={id}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      disabled={isLoading}
      className={className}
      size={size}
    />
  )
}
